export enum AppLanguage {
    German = 'GERMAN',
    English = 'ENGLISH',
    French = 'FRENCH',
    Italian = 'ITALIAN',
}

export enum UserLang {
    German = 'de',
    English = 'en',
    French = 'fr',
    Italian = 'it',
}
export const SUPPORTED_USER_LANG = [
    UserLang.English,
    UserLang.German,
    UserLang.French,
    UserLang.Italian,
];

export const DEVICE_LANG = 'i18nextLng';

export const SUPPORTED_APP_LANGUAGES_DATA = [
    {
        value: AppLanguage.German,
        i18n: UserLang.German,
    },
    {
        value: AppLanguage.English,
        i18n: UserLang.English,
    },
    {
        value: AppLanguage.French,
        i18n: UserLang.French,
    },
    {
        value: AppLanguage.Italian,
        i18n: UserLang.Italian,
    },
];

export enum Language {
    German = 'GERMAN',
    SwissGerman = 'SWISS_GERMAN',
    English = 'ENGLISH',
    French = 'FRENCH',
    Italian = 'ITALIAN',
    Bosnian = 'BOSNIAN',
    Croatian = 'CROATIAN',
    Serbian = 'SERBIAN',
    Turkish = 'TURKISH',
    Romanisch = 'ROMANISCH',
    Luxembourghish = 'LUXEMBOURGHISH',
    Hungarian = 'HUNGARIAN',
    Sweden = 'SWEDEN',
    Spanish = 'SPANISH',
    Dutch = 'DUTCH',
    Portuguese = 'PORTUGUESE',
}

export enum ProviderTitle {
    Psychologist = 'PSYCHOLOGIST',
    Psychotherapist = 'PSYCHOTHERAPIST',
}

export const PROVIDER_TITLE = {
    [ProviderTitle.Psychologist]: 'provider.title.psychologist',
    [ProviderTitle.Psychotherapist]: 'provider.title.psychotherapist',
};

export const ALL_PROVIDER_TITLES = [
    {
        label: 'provider.title.psychologist',
        value: ProviderTitle.Psychologist,
    },
    {
        label: 'provider.title.psychotherapist',
        value: ProviderTitle.Psychotherapist,
    },
];

export const StoryType = {
    Ambassador: 'ambassador',
    Expert: 'expert',
};

export enum ProviderArea {
    Aargau = 'AARGAU',
    Appenzell = 'APPENZELL',
    Basel = 'BASEL',
    Bern = 'BERN',
    Biel = 'BIEL',
    Fribourg = 'FRIBOURG',
    Geneva = 'GENEVA',
    Grisons = 'GRISONS',
    Luzern = 'LUZERN',
    Other = 'OTHER',
    Schaffhausen = 'SCHAFFHAUSEN',
    Schwyz = 'SCHWYZ',
    Solothurn = 'SOLOTHURN',
    StGallen = 'ST_GALLEN',
    Ticino = 'TICINO',
    Valais = 'VALAIS',
    Vaud = 'VAUD',
    Winterthur = 'WINTERTHUR',
    Zug = 'ZUG',
    Zurich = 'ZURICH',
}

export const PROVIDER_AREA_TRANSLATION_KEY: any = {
    [ProviderArea.Zurich]: 'provider.area.zurich',
    [ProviderArea.Winterthur]: 'provider.area.winterthur',
    [ProviderArea.Zug]: 'provider.area.zug',
    [ProviderArea.Basel]: 'provider.area.basel',
    [ProviderArea.Aargau]: 'provider.area.aargau',
    [ProviderArea.StGallen]: 'provider.area.stgallen',
    [ProviderArea.Bern]: 'provider.area.bern',
    [ProviderArea.Luzern]: 'provider.area.luzern',
    [ProviderArea.Schwyz]: 'provider.area.schwyz',
    [ProviderArea.Biel]: 'provider.area.biel',
    [ProviderArea.Schaffhausen]: 'provider.area.schaffhausen',
    [ProviderArea.Solothurn]: 'provider.area.solothurn',
    [ProviderArea.Valais]: 'provider.area.valais',
    [ProviderArea.Vaud]: 'provider.area.vaud',
    [ProviderArea.Fribourg]: 'provider.area.fribourg',
    [ProviderArea.Geneva]: 'provider.area.geneva',
    [ProviderArea.Ticino]: 'provider.area.ticino',
    [ProviderArea.Grisons]: 'provider.area.grisons',
    [ProviderArea.Appenzell]: 'provider.area.appenzell',
    [ProviderArea.Other]: 'provider.area.other',
};

export enum Gender {
    Agender = 'AGENDER',
    Female = 'FEMALE',
    Idk = 'IDK',
    Male = 'MALE',
    NoneBinary = 'NONE_BINARY',
    Other = 'OTHER',
    TransgenderFemale = 'TRANSGENDER_FEMALE',
    TransgenderMale = 'TRANSGENDER_MALE',
}

export enum FunnelQuoteType {
    Coaching = 'COACHING',
    Therapy = 'THERAPY',
}
